import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';

import merge from 'lodash/merge';
import isEmpty from 'lodash/fp/isEmpty';

import Text, { Small } from '../text';
import styles from './key-value-list-view.styles';
import { NO_DATA } from '../../../constants';

import TableRow from '../table-row';
import {
  Percent,
  Currency,
  SimpleNumber,
} from '../number';
import SimpleDate from '../date';

function KeyValueListRow({ label, value, unit, type, minimumFractionDigits, maximumFractionDigits, messages}) {
  function renderDetailsValue() {
    const sharedProps = {
      testID: 'value',
      style: styles.detailsText,
    };

    let fractions = merge({},
      minimumFractionDigits != undefined
        && { minimumFractionDigits: minimumFractionDigits },
      maximumFractionDigits != undefined
        && { maximumFractionDigits: maximumFractionDigits }
    );
    if (isEmpty(fractions)) fractions = getDefaultFractions(type);

    if (value == null) {
      return (
        <div aria-label={messages['app.common.nullValue']}>
          <Text>{NO_DATA}</Text>
        </div>
      )
    }

    if (type === 'date') {
      return (<SimpleDate
        value={value}
        renderProps={sharedProps}
      />);
    }

    if (type === 'currency') {
      return (
        <Currency
          value={value}
          currency={unit}
          renderProps={sharedProps}
          {...fractions}
        />
      );
    }

    if (type === 'number') {
      return (
        <SimpleNumber
          value={value}
          renderProps={sharedProps}
          {...fractions}
        />
      );
    }

    if (type === 'percent') {
      return (
        <Percent
          value={value}
          onlyNegativeStyling
          renderProps={sharedProps}
        />
      );
    }

    return <Text{...sharedProps}>{ value }</Text>;
  }

  function getDefaultFractions(type) {
    let defaultFractions = {};
    if (type === 'number') {
      defaultFractions = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      };
    }
    return defaultFractions;
  }

  if (!label) {
    return (
      <TableRow style={styles.detailsRow}>
        <TableRow.Column align="left">
          <Small style={styles.fullTextLabel} type="secondary" testID="value">
            {value}
          </Small>
        </TableRow.Column>
      </TableRow>
    );
  }

  return (
    <TableRow style={styles.detailsRow}>
      <TableRow.Column align="left" width={null}>
        <Text style={styles.detailsText} type="secondary" testID="label">{label}</Text>
      </TableRow.Column>
      <TableRow.Column wrap={false} width={1}>
        {renderDetailsValue()}
      </TableRow.Column>
    </TableRow>
  );
}

KeyValueListRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  unit: PropTypes.string,
  type: PropTypes.string,
  minimumFractionDigits: PropTypes.number,
  maximumFractionDigits: PropTypes.number,
};

export default pure(KeyValueListRow);
